// extracted by mini-css-extract-plugin
module.exports = {"container":"article-video_container__73Olx","content":"article-video_content__masCA"};